import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Menu from '@material-ui/core/Menu';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import MoreVertIcon from '@material-ui/icons/MoreVert';

const styles = theme => ({
    clickableRow: {
        cursor: 'pointer'
    },
    actionCol: {
        width: 1,
    },
    rowIconButtonRoot: {
        height: 40
    }
});

class DataTable extends React.Component {

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll, false);
    }
    
    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll, false);
    }
    
    onScroll = () => {
        const { rows, nextToken, onLoad } = this.props;
        if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 500)) {
            if(rows.length && nextToken !== null && typeof onLoad === "function") onLoad();
        }
    }

    toggleRowMenu = (event, el, index) => {
        const { onElementSelect, toggleRowMenu, onCloseToggleRowMenu } = this.props;
        const { currentTarget } = event;

        if (el !== null && el !== undefined) {
            onElementSelect(el, index);
        }

        toggleRowMenu(currentTarget);

        if (el === null || el === undefined) {
            onCloseToggleRowMenu();
        }
    }

    executeAction = () => {
        this.props.onActionClick();
    }

    handleDblClick = (event, el, index) => {
        this.clearSelection();
        const { defaultAction } = this.props;
        if (defaultAction) defaultAction(el, index);
    }

    clearSelection = () => {
        if (document.selection && document.selection.empty) {
            document.selection.empty();
        } else if (window.getSelection) {
            var sel = window.getSelection();
            sel.removeAllRanges();
        }
    }

    render() {
        const { columns, rows, toggleRowMenu, children, anchorEl, classes, defaultAction } = this.props;
        return (
            <React.Fragment>
                <Table>
                    <TableHead>
                        <TableRow>
                        {
                            [].concat(columns).map((col, colIndex) => <TableCell numeric={col.numeric} key={`table_header_cell_${colIndex}`}>{col.label}</TableCell>)
                        }
                        {
                            toggleRowMenu && <TableCell numeric>Actions</TableCell>
                        }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {
                        [].concat(rows).map((el, rowIndex) => {
                            return (
                                <TableRow key={`table_row_${rowIndex}`} className={(defaultAction && classes.clickableRow)}>
                                    {
                                        [].concat(columns).map((col, colIndex) => <TableCell numeric={col.numeric} onDoubleClick={event => this.handleDblClick(event, el, rowIndex)} key={`table_row_${rowIndex}_cell_${colIndex}`}>{
                                            col.format ? col.format(el[col.field]) : el[col.field]
                                        }</TableCell>)
                                    }
                                    {
                                        toggleRowMenu && 
                                        <TableCell classes={{ root: classes.actionCol }} numeric>
                                            <Tooltip title="Options">
                                                <IconButton classes={{ root: classes.rowIconButtonRoot }} aria-label="Options" onClick={event => this.toggleRowMenu(event, el, rowIndex)}>
                                                    <MoreVertIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    }
                                </TableRow>
                            );
                        })
                    }
                    </TableBody>
                </Table>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={event => this.toggleRowMenu(event, null, null)}>
                    {children}
                </Menu>
            </React.Fragment >
        );
    }
}

DataTable.propTypes = {
    classes: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
}

export default withStyles(styles, { withTheme: true })(DataTable);


// WEBPACK FOOTER //
// ./src/Components/Presentation/_Shared/DataTables/DataTable.js